import { GoogleApiWrapper } from 'google-maps-react';
import LocationAddressField from "./LocationAddressField";
export const WrappedLocationAddressField = GoogleApiWrapper(props => ({
  apiKey: props.apiKey,
  ...props
}))(LocationAddressField);
//# sourceMappingURL=WrappedLocationAddressField.js.map